import fetch from "common/js/fetch";

// 系统参数 type查
export function getSystemType(type) {
  return fetch("/core/v1/config/public/list", {type});
}



// WEBPACK FOOTER //
// ./src/api/public.js